
export default {
  name: 'MarkdownBlock',
  props: {
    content: {
      type: [String, Number]
    }
  }
}
